export default __webpack_public_path__ + "static/media/ifc.d22d7070.png";